// Powers collection product cards (snippets/collection-product-card.liquid): resolves
// VELO variant option cards (radio groups, one per option position) to the matching
// real variant, disables option values unavailable given the rest of the current
// selection (Dawn-like cross-option availability check), swaps price/compare-at-price/
// add-to-cart state/variant image, wires the custom black "Buy with Pay" CTA
// (data-card-apple-pay-cta) to the shared window.Velo.checkoutSelectedVariant action.
//
// Each card is independently scoped: the selector `[data-collection-product-card]`
// identifies the root, and all lookups (options, price, images, buttons) use
// .querySelector() relative to that root, so one card can never read or change
// another card's state. Variant resolution uses product.options_with_values +
// product.variants (positions/ids), never a variant title string match.
//
// Quantity is always visible/functional for every card, including Pack Size
// products (a real "Single"/"Pack of N" option, see
// snippets/pack-size-detect.liquid) - the shared +/- stepper
// (snippets/quantity-selector.liquid, assets/quantity-selector.js) is the ONLY
// quantity control. "Pack of N" is a storefront pricing option only: it
// submits the SINGLE variant with quantity x N, so a Single <-> Pack switch
// keeps the same cart SKU and the displayed quantity is preserved; only a
// genuine change of the submitted variant (e.g. a different colour) resets it
// via window.Velo.resetQuantitySelector. Add to Cart button price/label
// updates are owned entirely by the shared
// window.Velo.refreshAddToCartText(scope) - this file only keeps the button's
// data-price/data-is-single-variant/data-pack-multiplier in sync with the
// selection and calls that shared function whenever it changes.
(function () {
  var cards = document.querySelectorAll('[data-collection-product-card]');
  if (!cards.length) return;

  cards.forEach(function (card) {
    var cardProductId = card.getAttribute('data-product-id');
    if (!cardProductId) return;

    // Pack-builder cards (custom.pack_builder metafield, see
    // snippets/collection-product-card.liquid) render no <form> at all -
    // just "Build your pack" + an Apple Pay CTA that quick-buys tiers[0]'s
    // own default_split as real multi-variant line items, identical in
    // shape to assets/pack-builder.js's own buildItems(). Handled here,
    // before the `form` lookup below, since these cards never have one.
    var packBuilderJsonEl = card.querySelector('[data-card-pack-builder-json]');
    var packApplePayBtn = card.querySelector('[data-card-apple-pay-cta]');
    if (packBuilderJsonEl && packApplePayBtn) {
      (function initPackBuilderApplePay() {
        var pb = null;
        try {
          pb = JSON.parse(packBuilderJsonEl.textContent);
        } catch (e) {
          pb = null;
        }
        if (!pb || !pb.tiers || !pb.tiers.length || !pb.designs || pb.designs.length !== 2) return;
        if (!pb.designs[0].variant_id || !pb.designs[1].variant_id) return;

        var errorContainer = card.querySelector('[data-cart-error]');
        var propertyLabel = packApplePayBtn.dataset.cardPackPropertyLabel || 'Pack';
        var isArabic = document.documentElement.lang === 'ar' || document.documentElement.dir === 'rtl';

        var variantsById = {};
        var productJsonEl = card.querySelector('[data-product-json]');
        if (productJsonEl) {
          try {
            (JSON.parse(productJsonEl.textContent).variants || []).forEach(function (v) {
              variantsById[v.id] = v;
            });
          } catch (e) {}
        }

        // Quick tier pick (sections/featured-product.liquid's
        // [data-card-pack-tiers]) — optional; cards without it (e.g. plain
        // collection grid cards) keep the old fixed tiers[0] behaviour.
        var tierIndex = 0;
        var tier = pb.tiers[tierIndex];
        var counts = tier.default_split;
        var tierButtons = card.querySelectorAll('[data-card-pack-tier]');
        var tiersContainer = card.querySelector('[data-card-pack-tiers]');
        var piecesWord = tiersContainer ? tiersContainer.dataset.piecesLabel || '' : '';
        // data-featured-price / data-featured-pack-size live in the price
        // block above this card's own root (sections/featured-product.liquid
        // only wraps the Add to cart column in [data-collection-product-card],
        // not the whole Info block) — scope the lookup to the section instead
        // so this still no-ops safely on plain collection-grid cards that
        // have neither the section wrapper nor these elements.
        var sectionScope = card.closest('[data-pack-offer-section]') || card;
        var priceEl = sectionScope.querySelector('[data-featured-price]');
        var pieceLabelEl = sectionScope.querySelector('[data-featured-pack-size]');

        function refreshAvailability() {
          var available = pb.designs.every(function (design, i) {
            if (counts[i] <= 0) return true;
            var meta = variantsById[design.variant_id];
            return meta ? meta.available : true;
          });
          packApplePayBtn.disabled = !available;
        }

        function refreshPriceDisplay() {
          if (priceEl && window.Velo && window.Velo.formatMoney) {
            priceEl.textContent = window.Velo.formatMoney(Math.round(tier.price * 100));
          }
          if (pieceLabelEl) {
            pieceLabelEl.textContent = tier.size + ' ' + piecesWord;
          }
        }

        function selectTier(index) {
          if (index === tierIndex) return;
          tierIndex = index;
          tier = pb.tiers[tierIndex];
          counts = tier.default_split;
          tierButtons.forEach(function (btn, i) {
            var active = i === tierIndex;
            btn.classList.toggle('pack-builder__tier--selected', active);
            btn.setAttribute('aria-checked', active ? 'true' : 'false');
          });
          refreshAvailability();
          refreshPriceDisplay();
        }

        tierButtons.forEach(function (btn, i) {
          btn.addEventListener('click', function () {
            selectTier(i);
          });
        });

        refreshAvailability();

        packApplePayBtn.addEventListener('click', function () {
          if (packApplePayBtn.disabled) return;
          var tierLabel = isArabic ? tier.label_ar : tier.label_en;
          var properties = {};
          properties[propertyLabel] = tierLabel;
          properties._pack_locked = 'true';
          var items = [];
          pb.designs.forEach(function (design, i) {
            if (counts[i] > 0) {
              items.push({ id: design.variant_id, quantity: counts[i], properties: properties });
            }
          });
          window.Velo.checkoutSelectedVariant({
            items: items,
            button: packApplePayBtn,
            errorContainer: errorContainer
          });
        });
      })();
    }

    var form = card.querySelector('form');
    if (!form) return;

    var variantIdInput = form.querySelector('[data-card-variant-id]');
    var applePayBtn = card.querySelector('[data-card-apple-pay-cta]');
    var errorContainer = card.querySelector('[data-cart-error]');

    var jsonEl = card.querySelector('[data-product-json]');
    var data = null;
    if (jsonEl) {
      try {
        data = JSON.parse(jsonEl.textContent);
      } catch (e) {
        data = null;
      }
    }

    var variants = (data && data.variants) || [];
    var optionInputs = form.querySelectorAll('[data-option-position]');
    var priceEl = card.querySelector('[data-card-price]');
    var compareAtPriceEl = card.querySelector('[data-card-compare-at-price]');
    var mediaRoot = card.querySelector('[data-card-media]');
    var addToCartBtn = form.querySelector('[data-add-to-cart]');

    if (optionInputs.length && variantIdInput && variants.length) {
      (function initVariantCards() {
        function currentSelection() {
          var selection = {};
          optionInputs.forEach(function (input) {
            if (input.checked) selection[input.dataset.optionPosition] = input.value;
          });
          return selection;
        }

        function findVariant(selection) {
          var positions = Object.keys(selection);
          return variants.find(function (variant) {
            return positions.every(function (position) {
              return variant.options[position - 1] === selection[position];
            });
          });
        }

        function isValueAvailable(position, value, selection) {
          var hypothetical = Object.assign({}, selection);
          hypothetical[position] = value;
          var positions = Object.keys(hypothetical);
          return variants.some(function (variant) {
            var matches = positions.every(function (p) {
              return variant.options[p - 1] === hypothetical[p];
            });
            if (!matches) return false;
            // "Pack of N" is never added to the cart as itself, so its own
            // inventory is irrelevant - availability follows the Single
            // variant it resolves to.
            return window.Velo.resolvePackSubmission(variant, variants).variant.available;
          });
        }

        function updateCardStates(selection) {
          optionInputs.forEach(function (input) {
            var available = isValueAvailable(input.dataset.optionPosition, input.value, selection);
            input.disabled = !available;
            var variantCard = input.closest('.velo-variant-card');
            if (variantCard) {
              variantCard.classList.toggle('velo-variant-card--unavailable', !available);
              variantCard.classList.toggle('velo-variant-card--selected', input.checked);
            }
          });
        }

        var lastVariantId = null;

        // `selectedVariant` is what the option cards resolve to; `cartVariant`
        // is what actually gets POSTed. They differ only for "Pack of N",
        // which submits the SINGLE variant with a quantity multiplier.
        function updateForVariant(selectedVariant) {
          if (!selectedVariant) return;
          var submission = window.Velo.resolvePackSubmission(selectedVariant, variants);
          var cartVariant = submission.variant;

          // Only a genuine change of the SUBMITTED variant (not the initial
          // page-load refresh(), where lastVariantId is still null) resets
          // quantity, so a quantity chosen for one SKU never carries over to
          // another. Switching Single <-> Pack of 2 no longer counts: both
          // submit the same Single SKU, so the displayed quantity survives and
          // only the multiplier changes.
          var variantChanged = lastVariantId !== null && lastVariantId !== String(cartVariant.id);
          lastVariantId = String(cartVariant.id);
          if (variantChanged && window.Velo.resetQuantitySelector) {
            window.Velo.resetQuantitySelector(form);
          }

          variantIdInput.value = cartVariant.id;

          if (priceEl) {
            priceEl.textContent = window.Velo.formatMoney(cartVariant.price);
          }
          if (compareAtPriceEl) {
            var hasCompareAt = cartVariant.compare_at_price && cartVariant.compare_at_price > cartVariant.price;
            compareAtPriceEl.classList.toggle('hidden', !hasCompareAt);
            if (hasCompareAt) {
              compareAtPriceEl.textContent = window.Velo.formatMoney(cartVariant.compare_at_price);
            }
          }

          // Image follows the customer's actual selection, not the substituted
          // Single variant.
          if (mediaRoot && window.Velo) {
            if (selectedVariant.image) {
              window.Velo.showCardVariantImage(mediaRoot, selectedVariant.image);
            } else {
              window.Velo.hideCardVariantImage(mediaRoot);
            }
          }

          if (addToCartBtn) {
            addToCartBtn.disabled = !cartVariant.available;
            addToCartBtn.classList.toggle('opacity-50', !cartVariant.available);
            addToCartBtn.classList.toggle('cursor-not-allowed', !cartVariant.available);
            addToCartBtn.dataset.variantId = cartVariant.id;
            addToCartBtn.dataset.price = cartVariant.price;
            addToCartBtn.dataset.compareAtPrice = cartVariant.compare_at_price || 0;
            addToCartBtn.dataset.packMultiplier = submission.multiplier;
            addToCartBtn.dataset.isSingleVariant = cartVariant.options.some(function (value) {
              return String(value).trim().toLowerCase() === 'single';
            });
          }
          window.Velo.refreshAddToCartText(form);
          if (applePayBtn) {
            applePayBtn.disabled = !cartVariant.available;
          }
        }

        function refresh() {
          var selection = currentSelection();
          var variant = findVariant(selection);
          updateCardStates(selection);
          updateForVariant(variant);
        }

        optionInputs.forEach(function (input) {
          input.addEventListener('change', refresh);
        });

        refresh();
      })();
    }

    // Wire Apple Pay CTA (unconditionally, like in product-form.js)
    if (applePayBtn && variantIdInput) {
      applePayBtn.addEventListener('click', function () {
        if (applePayBtn.disabled) return;
        // Physical quantity (displayed x pack multiplier) and the Single
        // variant id - identical payload to the native form submit.
        var quantity = window.Velo.getPhysicalQuantity(form);
        window.Velo.checkoutSelectedVariant({
          variantId: variantIdInput.value,
          quantity: quantity,
          button: applePayBtn,
          errorContainer: errorContainer
        });
      });
    }
  });
})();
